<template>
  <el-container style="height: 100%">
    <layout-sider v-if="buildMode !== 'FHZ_WEB'" />
    <el-container direction="vertical">
      <layout-header v-if="buildMode !== 'FHZ_WEB'" />
      <layout-main />
      <!-- <layout-footer /> -->
    </el-container>
  </el-container>
</template>
<script>
import LayoutHeader from '../components/layout/layout-header.vue'
import LayoutSider from '../components/layout/layout-sider.vue'
import LayoutMain from '../components/layout/layout-main.vue'
// import LayoutFooter from '../components/layout/layout-footer.vue'
import { mapState } from 'vuex'
export default {
  name: 'Index',
  components: { LayoutHeader, LayoutSider, LayoutMain },
  data() {
    return {
      buildMode: process.env.VUE_APP_BUILD_MODE
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      permmisions: state => state.account.permmisions
    })
  }
}
</script>
